module.exports = __webpack_public_path__ + "media/app/images/event-48-white-f78021064913157bc3fa440129f67ed8.png";